import { BrandedEmailsSettingsRepository, EmailType } from '@packlink/packlink-sdk';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@sdk';

export const BRANDED_EMAILS_CACHE_KEY = 'branded-emails';
const brandedEmailsSettingsRepository = new BrandedEmailsSettingsRepository(apiClient);

export const useBrandedEmailImplementation = (emailType: EmailType, locale?: string) => {
    const {
        data: brandedEmailImplementation,
        isLoading,
        refetch: refetchBrandedEmailInitialValues,
    } = useQuery({
        queryKey: [BRANDED_EMAILS_CACHE_KEY, emailType, locale],
        queryFn: () => brandedEmailsSettingsRepository.getBrandedEmailImplementation(emailType, locale as string),
        enabled: locale !== undefined,
    });

    return {
        brandedEmailImplementation,
        isLoading,
        refetchBrandedEmailInitialValues,
    };
};
